export default function validate(fields) {
    const errors = {}
    const { clientId, siteId, zoneId, name, description } = fields
    if (typeof clientId === 'undefined' || clientId === '') {
        errors.clientId = 'Client Id must not be empty'
    }

    if (typeof siteId === 'undefined' || siteId === '') {
        errors.siteId = 'Site Id must not be empty'
    }

    if (typeof zoneId === 'undefined' || zoneId === '') {
        errors.zoneId = 'Zone Id must not be empty'
    }

    if (/\s/.test(zoneId)) {
        errors.zoneId = 'Zone Id must not contain spaces'
    }
    if (/[A-Z]/.test(zoneId)) {
        errors.zoneId = 'Zone Id must not contain capital letters'
    }

    if (typeof name === 'undefined' || name === '') {
        errors.name = 'Name must not be empty'
    }

    if (typeof description === 'undefined' || description === '') {
        errors.description = 'Description must not be empty'
    }
    return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/zone-form/validate.js